import { apiRTK, Tag } from 'api/api-rtk'

import type * as WorkSpace from './types'

export const workspaceApi = apiRTK.injectEndpoints({
	endpoints: create => ({
		automationMode: create.query<WorkSpace.AutoMode, void>({
			query: () => ({
				url: 'workspace/automation-mode'
			})
		}),

		setWorkingHours: create.mutation<void, Partial<WorkSpace.WorkingHours>>({
			async onQueryStarted(patch, { dispatch, queryFulfilled }) {
				const patchResult = dispatch(
					workspaceApi.util.updateQueryData('workingHours', undefined, draft =>
						Object.assign(draft, patch)
					)
				)

				try {
					await queryFulfilled
				} catch {
					patchResult.undo()
				}
			},
			query: hours => ({
				data: hours,
				method: 'PUT', // working as POST, rewrite all hours
				url: 'workspace/working-hours-in-minutes'
			})
		}),

		statistics: create.query<WorkSpace.Stats, WorkSpace.StatParams>({
			providesTags: [Tag.WorkspaceStats],
			query: params => ({
				params,
				url: 'workspace/period-statistics'
			})
		}),

		timezoneOffset: create.mutation<void, number>({
			invalidatesTags: [Tag.WorkspaceStats],
			query: offset => ({
				data: {
					timezone_offset: offset
				},
				method: 'PUT',
				url: 'workspace/timezone-offset'
			})
		}),
		workingHours: create.query<WorkSpace.WorkingHours, void>({
			query: () => ({
				url: 'workspace/working-hours-in-minutes'
			})
		})
	}),
	overrideExisting: true
})
